import { render } from "./OurProduct.vue?vue&type=template&id=7fecbba2"
import script from "./OurProduct.vue?vue&type=script&lang=js"
export * from "./OurProduct.vue?vue&type=script&lang=js"

import "./OurProduct.vue?vue&type=style&index=0&id=7fecbba2&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__